/**
 * @fileoverview Shared Subcategory schema used by both frontend and backend.
 */

import { z } from 'zod';
import { createCrudSchemas, createDisplayableEntitySchema, getSchemaFields } from './base.js';
import { ID_PATTERNS } from './types.js';

export const SubcategorySchema = createDisplayableEntitySchema(
  ID_PATTERNS.SUBCATEGORY,
  'ID must be in sc-prefixed nanoid7 format',
  { accountTracking: 'standard' }
);

const { CreateSchema, UpdateSchema } = createCrudSchemas(SubcategorySchema);

export const SubcategoryCreateSchema = CreateSchema;
export const SubcategoryUpdateSchema = UpdateSchema;

export type Subcategory = z.infer<typeof SubcategorySchema>;
export type SubcategoryCreate = z.infer<typeof SubcategoryCreateSchema>;
export type SubcategoryUpdate = z.infer<typeof SubcategoryUpdateSchema>;

export const SUBCATEGORY_FIELDS = getSchemaFields(SubcategorySchema);
